// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1Z17C","checkboxCol":"Table_checkboxCol__O1gAd","emailCol":"Table_emailCol__3_mFs","actionCol":"Table_actionCol__1Xsc2"};